import { render } from "./Works.vue?vue&type=template&id=089101ab"
import script from "./Works.vue?vue&type=script&lang=js"
export * from "./Works.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matteomelillo/Dev/wpHeadless/suisseconsulences.ch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__